var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.initialized,
            expression: "initialized",
          },
        ],
        staticClass: "form-grid",
      },
      [
        _c("label", { staticClass: "form-field" }, [
          _vm._v(
            "\n            " + _vm._s(_vm.$t("template")) + "\n            "
          ),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.templateType,
                  expression: "templateType",
                },
              ],
              attrs: { id: "newTemplate" },
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.templateType = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            [
              _c("option", { attrs: { value: "standard" } }, [
                _vm._v(_vm._s(_vm.$t("standardactvity"))),
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "sleep" } }, [
                _vm._v(_vm._s(_vm.$t("nightactivity"))),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("label", { staticClass: "form-field" }, [
          _vm._v(
            "\n            " + _vm._s(_vm.$t("activityname")) + "\n            "
          ),
          _c("input", {
            directives: [
              { name: "focus", rawName: "v-focus" },
              {
                name: "model",
                rawName: "v-model",
                value: _vm.record.title,
                expression: "record.title",
              },
            ],
            attrs: {
              name: "$t('labelTitle')",
              required: "",
              placeholder: "Enter name",
            },
            domProps: { value: _vm.record.title },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.record, "title", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("label", { staticClass: "form-field standard-field" }, [
          _vm._v(
            "\n            " + _vm._s(_vm.$t("startdate")) + "\n            "
          ),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.record.startDate,
                expression: "record.startDate",
              },
            ],
            attrs: { id: "startDate", type: "date" },
            domProps: { value: _vm.record.startDate },
            on: {
              change: _vm.setEndDate,
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.record, "startDate", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("label", { staticClass: "form-field" }, [
          _vm._v(
            "\n            " + _vm._s(_vm.$t("starttime")) + "\n            "
          ),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.record.startTimeNew,
                expression: "record.startTimeNew",
              },
            ],
            attrs: { id: "startTime", type: "time" },
            domProps: { value: _vm.record.startTimeNew },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.record, "startTimeNew", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("label", { staticClass: "form-field standard-field" }, [
          _vm._v(
            "\n            " + _vm._s(_vm.$t("enddate")) + "\n            "
          ),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.record.endDate,
                expression: "record.endDate",
              },
            ],
            attrs: {
              id: "endDate",
              type: "date",
              disabled: _vm.templateType != "sleep",
            },
            domProps: { value: _vm.record.endDate },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.record, "endDate", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("label", { staticClass: "form-field standard-field" }, [
          _vm._v("\n            Eindtijd\n            "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.record.endTimeNew,
                expression: "record.endTimeNew",
              },
            ],
            attrs: { id: "endTime", type: "time" },
            domProps: { value: _vm.record.endTimeNew },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.record, "endTimeNew", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "form-field" },
          [
            _vm._v(
              "\n            " + _vm._s(_vm.$t("location")) + "\n            "
            ),
            _c("selectoptions", {
              attrs: {
                url: "/location/all",
                value: _vm.record.locationId,
                settings: {
                  width: "100%",
                  allowClear: true,
                  placeholder: "Selecteer",
                },
                emptyname: "Kiezen",
              },
              model: {
                value: _vm.record.locationId,
                callback: function ($$v) {
                  _vm.$set(_vm.record, "locationId", $$v)
                },
                expression: "record.locationId",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("label", { staticClass: "form-field standard-field" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("numberofsupervisorsrequired")) +
              "\n            "
          ),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.record.requiredSupervisors,
                expression: "record.requiredSupervisors",
              },
            ],
            attrs: { id: "newNeeded", type: "number", min: "1", max: "20" },
            domProps: { value: _vm.record.requiredSupervisors },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.record, "requiredSupervisors", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-field full" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("requiredqualifications")))]),
          _vm._v(" "),
          _c(
            "table",
            { staticClass: "checkbox-grid" },
            _vm._l(_vm.educationqualifications, function (item) {
              return _c("tr", { staticClass: "check-option" }, [
                _c("td", [
                  _c("input", {
                    attrs: { type: "checkbox", value: "item.id" },
                    domProps: {
                      checked: _vm.record.educationQualifications.some(
                        (x) => x.id == item.id
                      ),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.setQualifications(
                          item,
                          $event.target.checked
                        )
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n                        " +
                      _vm._s(item.description) +
                      "\n                    "
                  ),
                ]),
              ])
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-field full" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("selectingyoungpeople")))]),
          _vm._v(" "),
          _c(
            "table",
            { staticClass: "checkbox-grid" },
            _vm._l(_vm.clients, function (item) {
              return _c("tr", { staticClass: "check-option" }, [
                _c("td", [
                  _c("input", {
                    attrs: { type: "checkbox", value: "item.id" },
                    domProps: {
                      checked: _vm.selectedUsers.some((x) => x.id == item.id),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.setSelectedUsers(item, $event.target.checked)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n                        " +
                      _vm._s(item.name) +
                      "\n                    "
                  ),
                ]),
              ])
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-field full",
            class: _vm.overrideUsers.length > 0 ? "" : "hidden",
            attrs: { id: "activityOverrideField" },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("reasonfordoubleplacement")) +
                "\n            "
            ),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.record.overrideReason,
                  expression: "record.overrideReason",
                },
              ],
              attrs: { id: "activityOverrideReason", rows: "2" },
              domProps: { value: _vm.record.overrideReason },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.record, "overrideReason", $event.target.value)
                },
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: { "margin-top": "10px" },
            attrs: { id: "activityWarnings" },
          },
          [
            _vm._l(_vm.overrideUsers, function (item) {
              return _c(
                "div",
                { staticClass: "issue red" },
                [
                  _c(
                    "font",
                    {
                      staticStyle: { "vertical-align": "inherit" },
                      attrs: { dir: "auto" },
                    },
                    [
                      _c(
                        "font",
                        {
                          staticStyle: { "vertical-align": "inherit" },
                          attrs: { dir: "auto" },
                        },
                        [
                          _vm._v(
                            "                            \n                        " +
                              _vm._s(item.name) +
                              "  staat op hetzelfde moment bij  " +
                              _vm._s(item.data) +
                              ".\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            _vm._v(" "),
            _vm._l(_vm.apperrors, function (item) {
              return _c(
                "div",
                { staticClass: "issue red" },
                [
                  _c(
                    "font",
                    {
                      staticStyle: { "vertical-align": "inherit" },
                      attrs: { dir: "auto" },
                    },
                    [
                      _c(
                        "font",
                        {
                          staticStyle: { "vertical-align": "inherit" },
                          attrs: { dir: "auto" },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(item) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
          ],
          2
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.initialized,
            expression: "initialized",
          },
        ],
        staticClass: "modal-actions",
      },
      [
        _c(
          "button",
          {
            staticClass: "btn close-modal",
            attrs: { "data-modal": "activityModal" },
            on: { click: _vm.dismiss },
          },
          [_vm._v(_vm._s(_vm.$t("cancel")))]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn primary",
            attrs: { id: "save" },
            on: { click: _vm.save },
          },
          [_vm._v(_vm._s(_vm.$t("createandaddtoschedule")))]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.initialized,
            expression: "!initialized",
          },
        ],
      },
      [_c("spinner")],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }